import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class CppSraAddProductSliderModelService {
  public addCppSraProductSlider: BehaviorSubject<boolean>;
  public CppSrasidenav: MatSidenav;
  private activeSliderValue: string;
  CppSraSliderCloseRqt: Subject<boolean>;
  CppSraModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccountNumber: number;
  public soldToAccountNumber: number;
  public isCustomerPickup: boolean;

  constructor() {
    this.addCppSraProductSlider = new BehaviorSubject(false);
    this.CppSraModelData = new BehaviorSubject(EMPTY);
    this.CppSraSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddCppSraProductSlider') {
      this.addCppSraProductSlider.next(true);
      this.CppSraModelData.next(EMPTY);
      this.CppSrasidenav.toggle();
    }
  }

  public SetCppSraSideNav(CppSraSideNavObj: MatSidenav) {
    this.CppSrasidenav = CppSraSideNavObj;
  }

  public CppSraClose() {
    this.CppSraModelData.next(EMPTY);
    this.addCppSraProductSlider.next(false);
    this.CppSrasidenav.close();
  }

  public setData<T>(obj: T) {
    this.CppSraModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.CppSraModelData.next(obj);
  }
}
